import { z } from 'zod';

import { USStrictAddress } from '../Address';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreatePropertyAddressEvent = BaseLoanEvent.extend({
  type: z.literal('createPropertyAddress'),
  newAddress: USStrictAddress,
});
export type CreatePropertyAddressEvent = z.infer<typeof CreatePropertyAddressEvent>;
